// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  CreateModelRequest,
  CreateModelResponse,
  DeleteModelRequest,
  DeleteModelResponse,
  GetAllModelsRequest,
  GetAllModelsResponse,
  GetModelRequest,
  GetModelResponse,
  GetRequiredModelsRequest,
  GetRequiredModelsResponse,
  UpdateModelRequest,
  UpdateModelResponse,
} from "./Models/ModelModels";

export const protobufPackage = "daisi.protos.v1";

export type ModelsProtoDefinition = typeof ModelsProtoDefinition;
export const ModelsProtoDefinition = {
  name: "ModelsProto",
  fullName: "daisi.protos.v1.ModelsProto",
  methods: {
    getRequiredModels: {
      name: "GetRequiredModels",
      requestType: GetRequiredModelsRequest,
      requestStream: false,
      responseType: GetRequiredModelsResponse,
      responseStream: false,
      options: {},
    },
    createModel: {
      name: "CreateModel",
      requestType: CreateModelRequest,
      requestStream: false,
      responseType: CreateModelResponse,
      responseStream: false,
      options: {},
    },
    getModel: {
      name: "GetModel",
      requestType: GetModelRequest,
      requestStream: false,
      responseType: GetModelResponse,
      responseStream: false,
      options: {},
    },
    getAllModels: {
      name: "GetAllModels",
      requestType: GetAllModelsRequest,
      requestStream: false,
      responseType: GetAllModelsResponse,
      responseStream: false,
      options: {},
    },
    updateModel: {
      name: "UpdateModel",
      requestType: UpdateModelRequest,
      requestStream: false,
      responseType: UpdateModelResponse,
      responseStream: false,
      options: {},
    },
    deleteModel: {
      name: "DeleteModel",
      requestType: DeleteModelRequest,
      requestStream: false,
      responseType: DeleteModelResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface ModelsProtoServiceImplementation<CallContextExt = {}> {
  getRequiredModels(
    request: GetRequiredModelsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetRequiredModelsResponse>>;
  createModel(
    request: CreateModelRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateModelResponse>>;
  getModel(request: GetModelRequest, context: CallContext & CallContextExt): Promise<DeepPartial<GetModelResponse>>;
  getAllModels(
    request: GetAllModelsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetAllModelsResponse>>;
  updateModel(
    request: UpdateModelRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<UpdateModelResponse>>;
  deleteModel(
    request: DeleteModelRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<DeleteModelResponse>>;
}

export interface ModelsProtoClient<CallOptionsExt = {}> {
  getRequiredModels(
    request: DeepPartial<GetRequiredModelsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetRequiredModelsResponse>;
  createModel(
    request: DeepPartial<CreateModelRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateModelResponse>;
  getModel(request: DeepPartial<GetModelRequest>, options?: CallOptions & CallOptionsExt): Promise<GetModelResponse>;
  getAllModels(
    request: DeepPartial<GetAllModelsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetAllModelsResponse>;
  updateModel(
    request: DeepPartial<UpdateModelRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<UpdateModelResponse>;
  deleteModel(
    request: DeepPartial<DeleteModelRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<DeleteModelResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
